<script lang="ts">
	interface Props {
		className?: string;
		width?: string;
	}

	let { className = '', width = 'w-4' }: Props = $props();
</script>

<div class="{className} flex items-center justify-center">
	<div class="animate-spin rounded-full {width} aspect-square border-b-2 border-current"></div>
</div>
